import "./Home.css";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Actions from "../../redux/actions/user.actions";
import { useSelector, useDispatch } from "react-redux";
import CompTreeGridV2 from "../../components/treegrid/CompTreeGridV2";
import Typography from "../../components/customdesign/Typography";
import { getResumeTasksByUser, prepareGetTasks } from "../../utils/Functions";
import { SkeletonComponent } from "@syncfusion/ej2-react-notifications";
import { Link } from "react-router-dom";

var windowWidth = window.innerWidth;

// Builds the dataSourceWFL + totals from the resume API result + menuWFL
function buildCardsData(tasks, menuWFL) {
  let dataWFL = [];
  let groups = [];
  let flows = [];
  let groupAssigned = 0;
  let groupActives = 0;
  let groupOuts = 0;

  menuWFL.forEach((g) => {
    if (groups.indexOf(g.FLOWGROUPID) >= 0) return;
    let gid = g.FLOWGROUPID;
    let hasChildG = false;

    menuWFL.forEach((f) => {
      let flowActives = 0;
      let flowAssigned = 0;
      let flowOuts = 0;
      if (f.FLOWGROUP !== g.FLOWGROUP) return;
      hasChildG = true;
      if (flows.indexOf(f.FLOWID) >= 0) {
        groupActives += flowActives;
        groupAssigned += flowAssigned;
        groupOuts += flowOuts;
        return;
      }

      let hasChildF = false;
      let fid = f.FLOWID;
      let _tasks = [];
      menuWFL.forEach((t) => {
        if (f.FLOWID !== t.FLOWID) return;
        if (_tasks.indexOf(t.TASKID) >= 0) return;
        let taskActives = 0;
        let taskAssigned = 0;
        let taskOuts = 0;
        tasks.forEach((key) => {
          if (key.FLOWID === t.FLOWID && key.TASKID === t.TASKID) {
            taskActives = key.TOTAL;
            taskAssigned = parseInt(key.TOTAL_ASSIGNED);
            taskOuts = parseInt(key.TOTAL_OUT);
          }
        });
        hasChildF = true;
        flowActives += taskActives;
        flowAssigned += taskAssigned;
        flowOuts += taskOuts;

        const taskKey = t.oldVersion ? fid + "_T" + t.TASKID : fid + "_" + t.TASKID;
        if (t.oldVersion && taskActives === 0) {
          _tasks.push(taskKey);
          return;
        }
        dataWFL.push({
          id: "TASK_" + fid + "_" + t.TASKID,
          taskid: t.TASKID,
          isTask: true,
          name: t.TASK.toLowerCase(),
          hasChild: false,
          pid: fid,
          link: "/getTasks/" + t.TASKID + "/" + fid,
          actives: taskActives,
          assigned: taskAssigned,
          out: taskOuts,
          sort: t.SORTORDER_F + (t.oldVersion ? "_" + t.SORTORDER_T : "_T" + t.SORTORDER_T),
        });
        _tasks.push(taskKey);
      });

      dataWFL.push({
        id: f.FLOWID,
        name: f.FLOW.toLowerCase(),
        hasChild: hasChildF,
        pid: gid,
        isFlow: true,
        actives: flowActives,
        assigned: flowAssigned,
        out: flowOuts,
        sort: f.SORTORDER_F + "",
      });
      flows.push(f.FLOWID);

      groupActives += flowActives;
      groupAssigned += flowAssigned;
      groupOuts += flowOuts;
    });

    groups.push(g.FLOWGROUPID);
    dataWFL.push({
      id: gid,
      pid: 999999,
      name: g.FLOWGROUP.toLowerCase(),
      hasChild: hasChildG,
      actives: groupActives,
      assigned: groupAssigned,
      out: groupOuts,
      sort: "2",
    });
  });

  dataWFL.sort((a, b) => (b.sort > a.sort ? -1 : b.sort < a.sort ? 1 : 0));
  return { dataWFL, groupActives, groupAssigned, groupOuts };
}

const Home = ({ openPanel, setOpenPanel }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { defConfig, defLang, usertoken, username, menu, menuWFL, tasks, requestingResumenTasks } =
    useSelector((state) => state.Login);
  const { refreshResumeTasks } = useSelector((state) => state.Process);

  const [dataSourceWFL, setDataSourceWFL] = React.useState([]);
  const [totalAssigned, setTotalAssigned] = React.useState(0);
  const [totalActives, setTotalActives] = React.useState(0);
  const [totalOuts, setTotalOuts] = React.useState(0);

  const [tasksheader, setTasksheader] = React.useState([]);
  const [rows, setRows] = React.useState([]);
  const [vars, setVars] = React.useState([]);
  const [showTransferStore, setShowTransferStore] = React.useState(false);
  const [transferStoreLabel, setTransferStoreLabel] = React.useState("TIENDAS TRASPASO");
  const [transferStoreRemarkable, setTransferStoreRemarkable] = React.useState(false);

  // Independent loading states for cards and table
  const [isCardsLoading, setIsCardsLoading] = React.useState(true);
  const [isTableLoading, setIsTableLoading] = React.useState(true);

  // ── Helpers ──────────────────────────────────────────────────────────

  const applyCardsData = React.useCallback((tasksResult) => {
    const { dataWFL, groupActives, groupAssigned, groupOuts } =
      buildCardsData(tasksResult, menuWFL);
    setDataSourceWFL(dataWFL);
    setTotalActives(groupActives);
    setTotalAssigned(groupAssigned);
    setTotalOuts(groupOuts);
    setIsCardsLoading(false);
  }, [menuWFL]);

  // ── Initial load ──────────────────────────────────────────────────────

  // Cards: use Redux `tasks` (already available from login) — no extra API call
  React.useEffect(() => {
    if (!usertoken) {
      navigate("/login");
      return;
    }
    if (!requestingResumenTasks && Array.isArray(menuWFL) && Array.isArray(tasks)) {
      applyCardsData(tasks);
    }
  }, [usertoken, menuWFL, tasks, requestingResumenTasks]);

  // Table: async, independent of cards
  React.useEffect(() => {
    if (!usertoken) return;
    setIsTableLoading(true);
    prepareGetTasks({ flowId: 0 })
      .then((r) => {
        setTasksheader(r.tasksheader);
        setRows(r.activetasks);
        setVars(r.flowvars);
        setShowTransferStore(r.showTransferStore || false);
        setTransferStoreLabel(r.transferStoreLabel || "TIENDAS TRASPASO");
        setTransferStoreRemarkable(r.transferStoreRemarkable || false);
      })
      .catch(() => {})
      .finally(() => setIsTableLoading(false));
  }, [usertoken]);

  // ── Refresh button ────────────────────────────────────────────────────

  const refreshData = React.useCallback(async () => {
    setIsTableLoading(true);

    // Both requests fire simultaneously
    const tablePromise = prepareGetTasks({ flowId: 0 }).then((r) => {
      setTasksheader(r.tasksheader);
      setRows(r.activetasks);
      setVars(r.flowvars);
      setShowTransferStore(r.showTransferStore || false);
      setTransferStoreLabel(r.transferStoreLabel || "TIENDAS TRASPASO");
      setTransferStoreRemarkable(r.transferStoreRemarkable || false);
      setIsTableLoading(false);
    });

    const cardsPromise = getResumeTasksByUser().then((r2) => {
      applyCardsData(r2.result);
    });

    await Promise.all([tablePromise, cardsPromise]);
  }, [applyCardsData]);

  // Handle Redux-triggered refresh (e.g. after executing a task)
  React.useEffect(() => {
    if (refreshResumeTasks) {
      dispatch(Actions.getResumeTasksByUser());
      refreshData();
    }
  }, [refreshResumeTasks]);

  // ── Skeleton helpers ──────────────────────────────────────────────────

  const cardSkeleton = () => (
    <div className="control-pane pl-1 pt-1">
      <div>
        <SkeletonComponent shape="Circle" width="85px" style={{ width: 85, height: 85, position: "relative", top: 45, left: 10 }} shimmerEffect="Pulse" />
        <SkeletonComponent shape="Rectangle" width="60%" style={{ width: "60%", height: 45, top: 10, float: "right", marginRight: 15 }} height="45px" shimmerEffect="Fade" />
        <SkeletonComponent shape="Rectangle" width="60%" style={{ width: "60%", height: 45, top: -12, float: "right", marginRight: 15 }} height="45px" shimmerEffect="Fade" />
        <SkeletonComponent shape="Rectangle" width="60%" style={{ width: "60%", height: 45, float: "right", marginRight: 15 }} height="45px" shimmerEffect="Fade" />
      </div>
    </div>
  );

  const tableSkeleton = () => (
    <div className="control-pane pl-1 pt-1">
      {[1, 2, 3, 4].map((i) => (
        <div key={i}>
          <SkeletonComponent shape="Rectangle" width="100%" style={{ float: "left", marginBottom: 10 }} height="45px" shimmerEffect="Fade" />
        </div>
      ))}
    </div>
  );

  // ── Render ────────────────────────────────────────────────────────────

  if (!usertoken) return null;

  return (
    <div className="xflow-dashboard-page">
      <div className="control-section" id="target_dash">

        {/* Hero */}
        <div className="xflow-dashboard-hero">
          <div>
            <span className="xflow-kicker">{defConfig[defLang].flowslabel}</span>
            <h1>Hola, {username}</h1>
            <p>{defConfig[defLang].mytaskslabel}</p>
          </div>
          <button className="e-btn e-primary xflow-dashboard-refresh" onClick={refreshData}>
            <span className="e-btn-icon e-icons e-refresh e-icon-left"></span>
            {defConfig[defLang].refreshlabel}
          </button>
        </div>

        {/* Stat cards */}
        <div className="col-lg-12 col-sm-12 col-md-12" id="dashboard_sidebar_section">
          <div id="analytic_target">
            <div className="sidebar-content" style={{ width: "100%" }}>
              <div className="dashboardParent">
                <div className="row" id="analytic_dashboard">

                  {/* Assigned */}
                  <div className="col-12 col-md-12 col-lg-4 mb-10 p-025">
                    <div className="card text-success xflow-stat-card xflow-stat-success">
                      {isCardsLoading ? cardSkeleton() : (
                        <>
                          <span className="e-btn-icon e-icons h3 text-bold bold-bordered-success">{totalAssigned}</span>
                          <div className="card-content text message-success xflow-stat-label">
                            {defConfig[defLang].takentaskslabel}
                          </div>
                          <div className="xflow-stat-body">
                            {dataSourceWFL.map((key, i) =>
                              key.isTask && key.assigned > 0 ? (
                                <div key={i} className="card-content item">
                                  <button onClick={() => navigate(key.link)}>
                                    {(key.name.length > 27 ? key.name.substring(0, 27) + ".." : key.name) + ": "}
                                    <span className="text-bold h5">{key.actives}</span>
                                  </button>
                                </div>
                              ) : null
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  {/* Active */}
                  <div className="col-12 col-md-12 col-lg-4 mb-10 p-025">
                    <div className="card text-primary xflow-stat-card xflow-stat-primary">
                      {isCardsLoading ? cardSkeleton() : (
                        <>
                          <span className="e-btn-icon e-icons h3 text-bold bold-bordered">{totalActives}</span>
                          <div className="card-content text message-primary xflow-stat-label">
                            {defConfig[defLang].activetaskslabel}
                          </div>
                          <div className="xflow-stat-body">
                            {dataSourceWFL.map((key, i) =>
                              key.isTask ? (
                                <div key={i} className="card-content item">
                                  <button onClick={() => navigate(key.link)}>
                                    {(key.name.length > 27 ? key.name.substring(0, 27) + ".." : key.name) + ": "}
                                    <span className="text-bold h5">{key.actives}</span>
                                  </button>
                                </div>
                              ) : null
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  {/* Expired */}
                  <div className="col-12 col-md-12 col-lg-4 mb-10 p-025">
                    <div className="card text-danger xflow-stat-card xflow-stat-danger">
                      {isCardsLoading ? cardSkeleton() : (
                        <>
                          <span className="e-btn-icon e-icons bold-bordered-danger h3 text-bold">{totalOuts}</span>
                          <div className="card-content text message-danger xflow-stat-label">
                            {defConfig[defLang].expiredtaskslabel}
                          </div>
                          <div className="xflow-stat-body">
                            {dataSourceWFL.map((key, i) =>
                              key.isTask && key.out > 0 ? (
                                <div key={i} className="card-content item">
                                  <button onClick={() => navigate(key.link)}>
                                    {(key.name.length > 27 ? key.name.substring(0, 27) + ".." : key.name) + ": "}
                                    <span className="text-bold h5">{key.actives}</span>
                                  </button>
                                </div>
                              ) : null
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Task table — solo escritorio */}
        {windowWidth > 768 && <div className="xflow-task-panel">
          <div className="col-lg-12 col-sm-12 col-md-12" id="dashboard_sidebar_section">
            <div>
              <Typography variant="h3" mb="1" mt="1" pl="1" style={{ textTransform: "capitalize" }}>
                <span className="e-component-title e-btn-icon e-icons e-group-2 e-icon-left"></span>
                <span className="e-component-title"> {defConfig[defLang].mytaskslabel}</span>
                {isTableLoading && (
                  <span style={{ fontSize: 12, fontWeight: 400, color: "#9ca3af", marginLeft: 10, verticalAlign: "middle" }}>
                    cargando...
                  </span>
                )}
              </Typography>

              {isTableLoading ? (
                tableSkeleton()
              ) : rows.length === 0 || !tasksheader?.length ? (
                <Typography variant="h5" mt={3} mb="0" pl="1">
                  <span>{defConfig[defLang].notaskslabel}</span>
                </Typography>
              ) : (
                <CompTreeGridV2
                  refreshData={refreshData}
                  noToolBar={true}
                  showTaskInfo={true}
                  defConfig={defConfig}
                  defLang={defLang}
                  taskId={0}
                  fixedHeight={windowWidth < 999 ? 560 : 265}
                  flowId={0}
                  header={tasksheader}
                  dataSource={rows}
                  vars={vars}
                  showTransferStore={showTransferStore}
                  transferStoreLabel={transferStoreLabel}
                  transferStoreRemarkable={transferStoreRemarkable}
                  name={"hometasks"}
                  cssClass="template-list"
                />
              )}
            </div>
          </div>
        </div>}

      </div>
    </div>
  );
};

Home.propTypes = {};

export default Home;
